import { render, staticRenderFns } from "./all_expiring_contracts.vue?vue&type=template&id=4bf2e044"
import script from "./all_expiring_contracts.vue?vue&type=script&lang=js"
export * from "./all_expiring_contracts.vue?vue&type=script&lang=js"
import style0 from "./all_expiring_contracts.vue?vue&type=style&index=0&id=4bf2e044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports